import { Badge } from '@/components/ui/badge'
import { Button } from '@/components/ui/button'
import type { FormPreviewMode, FormPreviewSource } from '@/contracts/form-preview'
import { Monitor, RefreshCw, Smartphone } from 'lucide-react'

export type FormPreviewDevice = 'desktop' | 'mobile'

export const formPreviewSourceLabel: Record<FormPreviewSource, string> = {
  builder_draft: 'Builder draft',
  persistent_mock: 'Persistent mock',
  public_preview: 'Public preview',
  question_group_template: 'Question group template',
}

export const formPreviewModeLabel: Record<FormPreviewMode, string> = {
  full_flow: '完整流程',
  selected_question: '單題預覽',
  logic_path: '流程預覽',
}

export function FormPreviewToolbar({
  title,
  source,
  mode,
  device,
  onDeviceChange,
  onRestart,
}: {
  title: string
  source: FormPreviewSource
  mode: FormPreviewMode
  device: FormPreviewDevice
  onDeviceChange: (device: FormPreviewDevice) => void
  onRestart: () => void
}) {
  return (
    <div className="flex min-h-14 flex-wrap items-center justify-between gap-3 border-b border-slate-200 bg-white px-4 py-3">
      <div className="min-w-0">
        <div className="flex flex-wrap items-center gap-2">
          <h2 className="truncate text-sm font-semibold text-slate-950">{title}</h2>
          <Badge variant="outline">preview-only</Badge>
          <Badge variant="secondary">mock-safe</Badge>
        </div>
        <div className="mt-1 flex flex-wrap items-center gap-2 text-xs text-slate-500">
          <span>{formPreviewModeLabel[mode]}</span>
          <span>·</span>
          <span>{formPreviewSourceLabel[source]}</span>
        </div>
      </div>
      <div className="flex items-center gap-2">
        <div className="inline-flex overflow-hidden rounded-md border border-slate-200 bg-slate-50 p-1">
          <Button
            type="button"
            size="sm"
            variant={device === 'desktop' ? 'default' : 'ghost'}
            onClick={() => onDeviceChange('desktop')}
          >
            <Monitor className="size-4" />
            桌機
          </Button>
          <Button
            type="button"
            size="sm"
            variant={device === 'mobile' ? 'default' : 'ghost'}
            onClick={() => onDeviceChange('mobile')}
          >
            <Smartphone className="size-4" />
            手機
          </Button>
        </div>
        <Button type="button" size="sm" variant="outline" onClick={onRestart}>
          <RefreshCw className="size-4" />
          重新開始
        </Button>
      </div>
    </div>
  )
}
